export default "__VITE_ASSET__Ud16KsHe__"